"use client";
import { useState, useEffect } from 'react';
import { subscribeToNewsletter } from '@/app/funcs/api';
import { isLoggedIn } from '@/app/funcs/api';
import { toast } from 'react-toastify';
import './newsletter.css';

export const NewsletterSubscription = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [loading, setLoading] = useState(false);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [subscriptionMessage, setSubscriptionMessage] = useState('');

    useEffect(() => {
        // Check if user is logged in and populate fields
        const checkUser = async () => {
            const loggedIn = await isLoggedIn();
            setUserLoggedIn(loggedIn);

            if (loggedIn) {
                try {
                    const userData = localStorage.getItem('user');
                    if (userData) {
                        const user = JSON.parse(userData);
                        // Set email if available
                        if (user.email) {
                            setEmail(user.email);
                        }
                        // Set name - try different possible fields
                        if (user.name) {
                            const nameParts = user.name.split(' ');
                            setFirstName(nameParts[0] || '');
                        } else if (user.display_name) {
                            const nameParts = user.display_name.split(' ');
                            setFirstName(nameParts[0] || '');
                        }
                    }
                } catch (error) {
                    console.error('Error parsing user data:', error);
                }
            }
        };

        checkUser();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!email || !email.includes('@')) {
            toast.error('يرجى إدخال بريد إلكتروني صحيح');
            return;
        }

        if (!firstName || firstName.trim() === '') {
            toast.error('يرجى إدخال الاسم الأول');
            return;
        }

        setLoading(true);

        try {
            const response = await subscribeToNewsletter(
                email.trim(),
                firstName.trim(),
                '--'
            );

            if (response.status === 201) {
                setIsSubscribed(true);
                setSubscriptionMessage('🎉 تم الاشتراك في النشرة الإخبارية بنجاح. شكراً لك');
            } else if (response.status === 200) {
                setIsSubscribed(true);
                setSubscriptionMessage('✅ أنت مشترك بالفعل في النشرة الإخبارية');
            } else {
                toast.warning('حدث خطأ غير متوقع');
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            if (error.response?.status === 200) {
                setIsSubscribed(true);
                setSubscriptionMessage('✅ أنت مشترك بالفعل في النشرة الإخبارية');
            } else {
                toast.error('حدث خطأ أثناء الاشتراك. يرجى المحاولة مرة أخرى');
            }
        } finally {
            setLoading(false);
        }
    };

    if (isSubscribed) {
        return (
            <div className="newsletter-subscription">
                <div className="newsletter-content">
                    <div className="newsletter-success">
                        <div className="newsletter-success-icon">
                            <i className="bi bi-check-circle-fill"></i>
                        </div>
                        <h5 className="newsletter-success-title">شكراً لك!</h5>
                        <p className="newsletter-success-message">{subscriptionMessage}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="newsletter-subscription">
            <div className="newsletter-content">
                <div className="newsletter-header">
                    <i className="bi bi-envelope-heart"></i>
                    <h5 className="newsletter-title">اشترك في النشرة الإخبارية</h5>
                </div>
                <p className="newsletter-description">
                    📬 ابق على اطلاع بآخر الأخبار والمحتوى الحصري من فيجماوية 
                    احصل على نصائح التصميم، أحدث المقالات، والفرص المهنية مباشرة في بريدك الإلكتروني.
                </p>
                <form onSubmit={handleSubmit} className="newsletter-form">
                    <div className="row g-2">
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="الاسم"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="col-12">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="البريد الإلكتروني"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="col-12">
                            <button
                                type="submit"
                                className="btn btn-primary w-100 newsletter-submit-btn"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        جاري الاشتراك...
                                    </>
                                ) : (
                                    <>
                                        اشترك الآن
                                        <i className="bi bi-send ms-2 flip-hh"></i>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
